import { InvitationDeclinedPage } from '~/components/pages/InvitationDeclinedPage';
import { PageTemplate } from '~/components/templates/PageTemplate';

export const InvitationDeclinedRoute: React.FC = () => {
  return (
    <PageTemplate>
      <InvitationDeclinedPage />
    </PageTemplate>
  );
};
